<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask" @click.self="closeModal">
      <div class="modal-container" ref="modalContainer">
        <div class="modal-header">
          <h5 class="modal-title">Edit Rekening</h5>
          <button
            type="button"
            class="modal-close"
            :disabled="isSubmitting"
            @click="closeModal"
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18 17.94 6M18 18 6.06 6"
              />
            </svg>
          </button>
        </div>

        <div class="modal-body settings-profile">
          <form @submit.prevent="submitEdit">
            <div
              v-if="validationError"
              class="alert alert-warning mt-0 mb-3"
              role="alert"
            >
              {{ validationError }}
            </div>

            <div class="form-row">
              <div class="col-md-12 mb-2">
                <label>Nama Bank</label>
                <select
                  v-model="selectedBank"
                  class="form-control w-100"
                  ref="selectElement"
                  :disabled="isSubmitting"
                >
                  <option value="">Pilih Bank</option>
                  <option
                    v-for="item in banks"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-12 mb-2">
                <label>Nama Akun</label>
                <input
                  style="color: #ffff"
                  type="text"
                  class="form-control"
                  placeholder="Nama Akun"
                  v-model="formBank.ac_name"
                  :disabled="isSubmitting"
                />
              </div>
              <div class="col-md-12 mb-2">
                <label>Nomor Akun</label>
                <input
                  style="color: #ffff"
                  type="text"
                  class="form-control"
                  placeholder="Nomor Akun"
                  v-model="formBank.ac_number"
                  :disabled="isSubmitting"
                />
              </div>
              <div class="col-md-12 mt-4">
                <button
                  class="btn btn-gradient"
                  type="submit"
                  :disabled="isSubmitting"
                >
                  <span
                    v-if="isSubmitting"
                    class="spinner-border spinner-border-sm mr-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span>{{
                    isSubmitting ? "Memvalidasi rekening..." : "Perbarui"
                  }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
/* global $ */
import { useToast } from "vue-toastification";
import thestore from "@/applibs/thestore.js";

const toast = useToast();

export default {
  props: {
    show: Boolean,
    banks: {
      type: Array,
      default: () => [],
    },
    bank: {
      type: Object,
      default: null,
    },
    token: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedBank: "",
      formBank: {
        ac_name: "",
        ac_number: "",
      },
      isSubmitting: false,
      validationError: "",
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.fillFromBank();
        this.$nextTick(() => this.handleSelect());
      } else {
        this.destroySelect();
        this.resetForm();
      }
    },
  },
  beforeUnmount() {
    this.destroySelect();
  },
  methods: {
    fillFromBank() {
      this.selectedBank = this.bank?.name || "";
      this.formBank = {
        ac_name: this.bank?.ac_name || "",
        ac_number: this.bank?.ac_number || "",
      };
      this.validationError = "";
    },
    resetForm() {
      this.selectedBank = "";
      this.formBank = {
        ac_name: "",
        ac_number: "",
      };
      this.validationError = "";
      this.isSubmitting = false;
    },
    closeModal() {
      if (this.isSubmitting) return;
      this.$emit("update:show", false);
      this.$emit("close");
    },
    destroySelect() {
      const el = this.$refs.selectElement;
      if (!el) return;

      const $el = $(el);
      if ($el.data("select2")) {
        $el.off("change");
        $el.select2("destroy");
      }
    },
    handleSelect() {
      const el = this.$refs.selectElement;
      const parent = this.$refs.modalContainer;
      if (!el || !parent) return;

      const $el = $(el);
      if ($el.data("select2")) {
        $el.select2("destroy");
      }

      $el
        .select2({
          dropdownParent: $(parent),
          width: "100%",
        })
        .val(this.selectedBank)
        .trigger("change")
        .on("change", (event) => {
          this.selectedBank = event.target.value;
        });
    },
    async submitEdit() {
      if (this.isSubmitting || !this.bank?.id) return;

      this.validationError = "";

      if (!this.selectedBank) {
        this.validationError = "Nama bank wajib dipilih";
        toast.warning(this.validationError);
        return;
      }
      if (!this.formBank.ac_name || !String(this.formBank.ac_name).trim()) {
        this.validationError = "Nama akun wajib diisi";
        toast.warning(this.validationError);
        return;
      }
      if (
        !this.formBank.ac_number ||
        !String(this.formBank.ac_number).trim()
      ) {
        this.validationError = "Nomor rekening wajib diisi";
        toast.warning(this.validationError);
        return;
      }

      this.isSubmitting = true;
      try {
        const res = await thestore.updateMyBank(
          this.token,
          this.bank.id,
          this.selectedBank,
          this.formBank.ac_name,
          this.formBank.ac_number
        );

        if (res.success == true) {
          this.$emit("updated", res);
          toast.success("Akun bank berhasil diperbarui");
          this.$emit("update:show", false);
        } else {
          this.validationError =
            res.msg ||
            "Validasi rekening gagal. Silakan periksa data rekening Anda.";
          toast.warning(this.validationError);
        }
      } catch (error) {
        const apiMsg =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.message;
        this.validationError =
          apiMsg ||
          "Validasi rekening gagal: tidak dapat menghubungi server. Silakan coba lagi.";
        toast.warning(this.validationError);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  position: relative;
  width: 100%;
  max-width: 520px;
  margin: 16px;
  background-color: #1e222d;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  overflow: visible;
}

.modal-container :deep(.select2-container) {
  width: 100% !important;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 0;
}

.modal-title {
  color: #fff;
  font-weight: 600;
  margin: 0;
}

.modal-close {
  background: transparent;
  border: none;
  color: #c5c8d0;
  padding: 4px;
  cursor: pointer;
}

.modal-close:hover {
  color: #ffffff;
}

.modal-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-body {
  padding: 20px;
}

.modal-body label {
  color: #ffffff;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.96);
}

.btn-gradient:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-gradient .spinner-border {
  vertical-align: text-bottom;
}
</style>
